module.exports = __webpack_public_path__ + "img/default-avatar.02ed4e53.png";